import React from 'react';

import { SubHeading } from '../../components';
import { data, images } from '../../constants';
import './Services.css';


const ServiceCard = ({ service: {imgUrl, title} }) => (
  <div className="app__services-card">
    <img src={imgUrl} alt="garis" />
    <div className="app__services-card_content">
      <p className="p__cormorant" style={{ color: "#DCCA87"}}>{title}</p>
    </div>
  </div>
)
const Services = () => (
  <div className="app__bg app__wrapper section__padding" id="service">
    <div className="app__wrapper_info">
      <SubHeading title="Daftar Pelayanan kami" />
      <h1 className="headtext__cormorant">Pelayanan Kami</h1>

      <div className="app__services">
        {data.services.map((service) => <ServiceCard service={service} key={service.title}/>)}
      </div>
    </div>
    <div className="app__wrapper_img">
      <img src={images.service} alt="service" />
    </div>
  </div>
);

export default Services;
